module.exports = __webpack_public_path__ + "img/stock1.c90fc219.png";